import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import FormsModalHIH from './FormsModal/FormsModalHIH';
import { Modal } from 'react-bootstrap';
import { fetchAIServiceRecommendations, dismissAIServiceRecommendations, fetchDropdownList } from '../../services/hih/Service';

const ServiceRecommendations = ({ membershipNo, memberBasicInfo, handleFamilyMemberProfileClick }) => {

    useEffect(() => {
        getAiBupaServiceRecommendations(membershipNo);
    }, [membershipNo])
    const [aiBupaServiceRecommendations, setAiBupaServiceRecommendations] = useState([]);

    const [dismissalServiceType, setDismissalServiceType] = useState("");
    const [aiBupaServiceDismissalReasonsList, setAIBupaServiceDismissalReasonsList] = useState([]);
    const [aiBupaServiceDismissalReason, setAIBupaServiceDismissalReason] = useState("");
    const [aiBupaServiceDismissalComments, setAIBupaServiceDismissalComments] = useState("");
    const [showAIBupaServiceDismissalModal, setShowAIBupaServiceDismissalModal] = useState(false);
    const [aiBupaServiceRecommendationIDs, setAIBupaServiceRecommendationIDs] = useState("");
    const [aiBupaServiceDismissalError, setAIBupaServiceDismissalError] = useState("");

    const [labRecommendationSource, setLabRecommendationSource] = useState("");
    const [medicineRecommendationSource, setMedicineRecommendationSource] = useState("");

    //console.log(JSON.stringify(aiBupaServiceRecommendations));
    //Forms
    const [modalTitle, setModalTitle] = useState(false);
    const [formShort, setFormShort] = useState('');
    const [showMedicationModal, setShowMedicationModal] = useState(false);
    const handleCloseMedicationModal = () => setShowMedicationModal(false);

    const getAiBupaServiceRecommendations = async (membershipNumber) => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchAIServiceRecommendations(membershipNumber, ct)
            .then((response) => {
                if (response.data.code === 200) {
                    setAiBupaServiceRecommendations(response.data.data.recommendations);
                    setLabRecommendationSource(response.data.data.labRecommendationSource);
                    setMedicineRecommendationSource(response.data.data.medicineRecommendationSource);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleAIBupaServiceRecommendationsDismissal = async () => {
        if (aiBupaServiceDismissalReason.trim() == "") {
            setAIBupaServiceDismissalError("Please select the reason");
            setAIBupaServiceDismissalComments("");
        } else {
            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }

            console.log(dismissalServiceType, aiBupaServiceRecommendations);
            let recommendationIds = "";
            if (dismissalServiceType == "refill") {
                recommendationIds = aiBupaServiceRecommendations
                    .flatMap(item => item.medicines.map(med => med.recommendationId))
                    .join(",");
            }

            if (dismissalServiceType == "lab") {
                recommendationIds = aiBupaServiceRecommendations
                    .flatMap(item => item.labs.map(med => med.recommendationId))
                    .join(",");
            }

            if (recommendationIds != "") {
                await dismissAIServiceRecommendations(recommendationIds, aiBupaServiceDismissalReason, aiBupaServiceDismissalComments, ct)
                    .then((response) => {
                        if (response.data.code === 200) {
                            getAiBupaServiceRecommendations(memberBasicInfo.membershipNumber);
                            setShowAIBupaServiceDismissalModal(false);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                return () => request.cancel();
            } else {
                setAIBupaServiceDismissalError("No recommendation found to dismiss");
            }
        }

    }

    const getAIBupaServiceDismissalReasonsList = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchDropdownList('aibupaservicerecommendationdismissreason', ct)
            .then((response) => {
                if (response.data.code === 200) {
                    setAIBupaServiceDismissalReasonsList(response.data.data.options);
                    setShowAIBupaServiceDismissalModal(true);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleShowMedicationModal = (header, formShortName) => {
        //setSelectedServiceRecord(selectedRecordObject);
        setModalTitle(header);
        setFormShort(formShortName);
        setShowMedicationModal(true);
    }



    return (
        <>
            {
                aiBupaServiceRecommendations.length > 0 &&
                <div className='col-md-12 mt-3'>
                    <div className='profile-card-new'>

                        <div className='row align-items-center'>
                            <div className="col"><h5 className="card-title">Recommendations and Actions</h5></div>
                            {
                                aiBupaServiceRecommendations.length > 0 &&
                                <>
                                    {/* Loop for Medicines */}
                                    {
                                        aiBupaServiceRecommendations[0]?.medicines?.length > 0 &&
                                        <div className='col-md-12 mt-2' >
                                            <label htmlFor="" className="status mb-1"><b>Medication Request - {medicineRecommendationSource}</b></label>
                                            <div className='profile-box-n1 p-2 ps-3' style={{ backgroundColor: "#ffedd7" }}>
                                                <div className='row align-items-center'>
                                                    <div className="info-line col">
                                                        <div className='row'>
                                                            {
                                                                aiBupaServiceRecommendations[0]?.medicines?.map((medItem, medIndex) => (
                                                                    <div className='col-md-auto margin-mb' key={`med-${medIndex}`}>
                                                                        <h5 className="program mb-0">
                                                                            <i class="bi bi-capsule-pill me-2" style={{ color: "#feb558", fontSize: "16px" }} aria-hidden="true"></i>
                                                                            {medItem.serviceDesc + " - " + medItem.servicelineItemQuantity}
                                                                        </h5>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-auto info-line d-flex">
                                                        <button className="action-button blue-btn me-2"
                                                            style={{ fontSize: "12px", padding: "6px 10px", fontWeight: "500", height: 'fit-content' }}
                                                            onClick={() => {
                                                                setDismissalServiceType("refill");
                                                                getAIBupaServiceDismissalReasonsList();
                                                            }}
                                                        >Dismiss</button>
                                                        <button className="action-button blue-btn"
                                                            style={{ fontSize: "12px", padding: "6px 10px", fontWeight: "500", height: 'fit-content' }}
                                                            onClick={(e) => handleShowMedicationModal("Medication Request", memberBasicInfo.homeService?.med === "Y" ? "medmetadoc" : "med")}
                                                        >Recommend</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }


                                    {/* Loop for Labs */}

                                    {
                                        aiBupaServiceRecommendations[0]?.labs?.length > 0 &&
                                        <div className='col-md-12 mt-2' >
                                            <label htmlFor="" className="status mb-1"><b>Lab Request - {labRecommendationSource} </b></label>
                                            <div className='profile-box-n1 p-2 ps-3' style={{ backgroundColor: "#ffedd7" }}>
                                                <div className='row align-items-center'>
                                                    <div className="info-line col">
                                                        <div className='row'>
                                                            {
                                                                aiBupaServiceRecommendations[0]?.labs?.map((labItem, labIndex) => (
                                                                    <div className='col-md-6 margin-mb' key={`lab-${labIndex}`}>
                                                                        <h5 className="program mb-0">
                                                                            <i class="bx bx-test-tube me-2" style={{ color: "#267ca1", fontSize: "16px" }} aria-hidden="true"></i>
                                                                            {labItem.serviceDesc + " - " + labItem.servicelineItemQuantity}
                                                                        </h5>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-auto info-line d-flex">
                                                        <button className="action-button blue-btn me-2"
                                                            style={{ fontSize: "12px", padding: "6px 10px", fontWeight: "500", height: 'fit-content' }}
                                                            onClick={() => {
                                                                setDismissalServiceType("lab");
                                                                getAIBupaServiceDismissalReasonsList();
                                                            }}
                                                        >Dismiss</button>
                                                        <button className="action-button blue-btn"
                                                            style={{ fontSize: "12px", padding: "6px 10px", fontWeight: "500", height: 'fit-content' }}
                                                            onClick={(e) => handleShowMedicationModal("Lab Request", memberBasicInfo.homeService?.hbl === "Y" ? "hblmetadoc" : "hbl")}
                                                        >Recommend</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </>
                            }
                        </div>
                    </div>
                </div>
            }
            <FormsModalHIH formShort={formShort} header={modalTitle} memberBasicInfo={memberBasicInfo} showMedicationModal={showMedicationModal} handleShowMedicationModal={handleShowMedicationModal} handleCloseMedicationModal={handleCloseMedicationModal} aiBupaServiceRecommendations={aiBupaServiceRecommendations} getAiBupaServiceRecommendations={getAiBupaServiceRecommendations} handleFamilyMemberProfileClick={handleFamilyMemberProfileClick} />

            {/*AI Bupa Dismissal Modal*/}
            <Modal id="AIBupaDismissalModal" show={showAIBupaServiceDismissalModal} onHide={() => setShowAIBupaServiceDismissalModal(false)} centered size="" backdrop="static" keyboard={false} fullscreen={false}>
                <Modal.Header closeButton>
                    <h1 className='modal-title'>Dismiss Service Recommendations</h1>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12 mb-3'>
                            <label className="form-label">Reason to dismiss: <span className='required'>*</span></label>
                            <select className="form-select select-input-ui" value={aiBupaServiceDismissalReason} onChange={(e) => setAIBupaServiceDismissalReason(e.target.value)}>
                                <option value="">Select</option>
                                {
                                    aiBupaServiceDismissalReasonsList.map((item, index) => {
                                        return <option value={item.dropdownValue} key={index}>{item.dropdownLabel}</option>
                                    })
                                }
                            </select>
                        </div>

                        <div className='col-12 mb-3'>
                            <label className="form-label">Remarks: </label>
                            <textarea name="notes" className='form-control control-input-ui' placeholder='Enter Remarks' onChange={(e) => setAIBupaServiceDismissalComments(e.target.value)} value={aiBupaServiceDismissalComments}></textarea>
                        </div>

                        <div className='col-12 text-center'>
                            <div className={`${aiBupaServiceDismissalError != "" ? "errorDiv" : "hide"}`}>{aiBupaServiceDismissalError}</div>

                            <button className="btn btn-primary save-btn me-3" onClick={handleAIBupaServiceRecommendationsDismissal}>Save</button>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ServiceRecommendations